/**
 * Maison Grès — one stay per cart: clear existing lines, then add the current reservation.
 */
(function () {
  const Av = () => window.MaisonAvailability;

  function parseYMD(s) {
    return Av()?.parseYMD(s) || null;
  }

  function nightsBetween(inDate, outDate) {
    if (!inDate || !outDate) return 1;
    const ms = outDate.getTime() - inDate.getTime();
    return Math.max(1, Math.round(ms / (1000 * 60 * 60 * 24)));
  }

  function readBlockedRules(root) {
    const rulesEl = root?.querySelector('[data-maison-blocked-rules]');
    if (!rulesEl || !Av()) return new Set();
    let raw = '';
    try {
      raw = JSON.parse(rulesEl.textContent || '""');
    } catch {
      raw = rulesEl.textContent || '';
    }
    return Av().expandRules(raw);
  }

  function showAvailabilityError(root, message) {
    const el = root?.querySelector('[data-maison-availability-error]');
    if (!el) return false;
    el.textContent = message;
    el.hidden = false;
    el.focus?.();
    return true;
  }

  function initProductReserveForms(scope) {
    const root = scope || document;
    root.querySelectorAll('[data-maison-reserve-form]').forEach((form) => {
      if (form.dataset.maisonReserveReady === 'true') return;
      form.dataset.maisonReserveReady = 'true';

      form.addEventListener('submit', async (event) => {
        event.preventDefault();

        const calendarRoot = form.closest('[data-maison-calendar-root]');
        const btn = form.querySelector('[type="submit"]');
        const checkInEl = form.querySelector('[data-prop-checkin]');
        const checkOutEl = form.querySelector('[data-prop-checkout]');
        const unavailableMessage =
          calendarRoot?.dataset.availabilityError ||
          'Those dates are not available. Please choose different dates.';
        const datesRequiredMessage =
          calendarRoot?.dataset.datesRequiredError || 'Please select check-in and check-out dates.';

        if (!checkInEl?.value || !checkOutEl?.value) {
          if (!showAvailabilityError(calendarRoot, datesRequiredMessage)) {
            window.alert(datesRequiredMessage);
          }
          return;
        }

        const checkIn = parseYMD(checkInEl.value);
        const checkOut = parseYMD(checkOutEl.value);
        const blockedSet = readBlockedRules(calendarRoot);

        if (Av()?.stayHasBlockedNight(checkIn, checkOut, blockedSet)) {
          if (!showAvailabilityError(calendarRoot, unavailableMessage)) {
            window.alert(unavailableMessage);
          }
          return;
        }

        if (btn) {
          btn.disabled = true;
          btn.setAttribute('aria-busy', 'true');
        }

        const variantId = form.querySelector('[name="id"]')?.value;
        if (!variantId) {
          form.submit();
          return;
        }

        const qtyEl = form.querySelector('[data-qty]');
        const guestsEl = form.querySelector('[data-prop-guests]');
        const guestsSelect = calendarRoot?.querySelector('[data-guests]');

        const nights = nightsBetween(checkIn, checkOut);
        if (qtyEl) qtyEl.value = String(nights);

        const guestsVal = guestsSelect?.value || '2';
        if (guestsEl) guestsEl.value = `${guestsVal} guests`;

        const properties = {};
        if (checkInEl?.value) properties['Check-in'] = checkInEl.value;
        if (checkOutEl?.value) properties['Check-out'] = checkOutEl.value;
        if (guestsEl?.value) properties.Guests = guestsEl.value;

        const redirect = form.getAttribute('data-maison-redirect') || '/cart';

        try {
          await fetch(`${window.Shopify?.routes?.root || '/'}cart/clear.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'same-origin'
          });

          const addRes = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({
              items: [
                {
                  id: Number(variantId),
                  quantity: nights,
                  properties
                }
              ]
            })
          });

          if (!addRes.ok) {
            const err = await addRes.json().catch(() => ({}));
            throw new Error(err.description || err.message || 'Could not add to cart');
          }

          window.location.href = redirect;
        } catch (e) {
          console.error('Maison reserve failed', e);
          if (btn) {
            btn.disabled = false;
            btn.removeAttribute('aria-busy');
          }
          form.submit();
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initProductReserveForms());
  } else {
    initProductReserveForms();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initProductReserveForms(event.target);
  });
})();
